import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { ContentInner } from '../layout/Content'
import SettingsInnerStyle from './css/SettingsInnerStyle'
import { appContext } from '../../App'
import ModalWindow from '../layout/modalwindow/ModalWindow'
import WarehouseForm from './forms/WarehouseForm'
import VATForm from './forms/VATForm'
import NPOSAccountController from './components/npos_account/NPOSAccountController'
import { settingsControllerContext } from './SettingsController'

function SettingsInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const settingsController = useContext(settingsControllerContext)
  const vatSettings = settingsController.vatSettings[0]
  const updateVATSettings = settingsController.vatSettings[1]
  const { getWarehouses, getWarehouseById, saveWarehouse, deleteWarehouse } = settingsController

  const onClickWarehouse = (e) => {
    const warehouseFormProps = { app, getWarehouses, getWarehouseById, saveWarehouse, deleteWarehouse }
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header={'Warehouses'}
        footer={null}
        width={50}
        height={60}>
        <WarehouseForm { ...warehouseFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickVAT = (e) => {
    const vatFormProps = { vatSettings, updateVATSettings }

    ReactDOM.render(
      <ModalWindow
        header='Set VAT'
        footer={null}>
        <VATForm { ...vatFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickNPOSAccount = (e) => { setContent(<NPOSAccountController />) }

  return (
    <ContentInner>
      <div className='settings-container'>
        <button
          id='warehouses-button'
          onClick={onClickWarehouse}
          className='settings-item-wrapper'>
          <div className='settings-item-title'>Warehouses</div>
          <div className='settings-item-description'>
            Manage warehouses...
          </div>
        </button>

        <button
          id='vat-button'
          onClick={onClickVAT}
          className='settings-item-wrapper'>
          <div className='settings-item-title'>VAT</div>
          <div className='settings-item-description'>
            Change VAT value ({(vatSettings) ? <span>{parseFloat(vatSettings.value)}%</span> : null})
          </div>
        </button>

        <button
          id='npos-accounts-settings-button'
          onClick={onClickNPOSAccount}
          className='settings-item-wrapper'>
          <div className='settings-item-title'>Account Settings</div>
          <div className='settings-item-description'>
            Manage Accounts, etc...
          </div>
        </button>
      </div>
      <SettingsInnerStyle signed_in={app.client.signed_in} />
    </ContentInner>
  )
}

export default React.memo(SettingsInner)